var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative inline-block",class:{ 'select-none cursor-not-allowed': _vm.loading }},[_c('LoadingOverlay',{attrs:{"is-loading":_vm.loading}},[_c('BaseButton',_vm._b({},'BaseButton',_vm.$attrs,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }